export default __webpack_public_path__ + "static/media/Tabalhadores.d2185369.png";